import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_BODY_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_BODY_MODE,
  CHANGE_TOPBAR_THEME,
  SHOW_RIGHT_SIDEBAR,
  SHOW_SIDEBAR,
  TOGGLE_LEFTMENU,
  RESET_LAYOUT_STATE,
} from '../types/layout';

import {
  layoutTypes,
  layoutWidth,
  leftSideBarTheme,
  bodyTheme,
  bodyMode,
  leftSideBarType,
  topbarTheme,
} from '../../constants/layout';

const initialState = {
  layoutType: layoutTypes.VERTICAL,
  layoutWidth: layoutWidth.FLUID,
  leftSideBarTheme: leftSideBarTheme.DARK,
  bodyTheme: bodyTheme.LIGHT,
  bodyMode: bodyMode.RTL,
  leftSideBarType: leftSideBarType.DEFAULT,
  topbarTheme: topbarTheme.LIGHT,
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
};

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LAYOUT:
      return Object.assign({}, state, {
        layoutType: action.payload,
      });

    case CHANGE_LAYOUT_WIDTH:
      return Object.assign({}, state, {
        layoutWidth: action.payload,
      });

    case CHANGE_SIDEBAR_THEME:
      return Object.assign({}, state, {
        leftSideBarTheme: action.payload,
      });

    case CHANGE_BODY_THEME:
      return Object.assign({}, state, {
        bodyTheme: action.payload,
      });

    case CHANGE_BODY_MODE:
      return Object.assign({}, state, {
        bodyMode: action.payload,
      });

    case CHANGE_SIDEBAR_TYPE:
      return Object.assign({}, state, {
        leftSideBarType: action.payload.sidebarType,
        isMobile: action.payload.isMobile || false,
      });

    case CHANGE_TOPBAR_THEME:
      return Object.assign({}, state, {
        topbarTheme: action.payload,
      });

    case SHOW_RIGHT_SIDEBAR:
      return Object.assign({}, state, {
        showRightSidebar: action.payload,
      });

    case SHOW_SIDEBAR:
      return Object.assign({}, state, {
        showSidebar: action.payload,
      });

    case TOGGLE_LEFTMENU:
      return Object.assign({}, state, {
        leftMenu: action.payload,
      });

    case RESET_LAYOUT_STATE:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default layoutReducer;
